<mat-card class="callHistoryCard">
  <div class="header">
    <div>
      <div class="titleRow">
        <h2>Звонки</h2>
        <span class="resultCounter" *ngIf="!loading && calls.length">{{ calls.length }}</span>
      </div>
      <p>{{ periodLabel || 'Последние 90 дней' }} · до 100 последних звонков</p>
    </div>

    <button
      type="button"
      mat-stroked-button
      color="primary"
      (click)="load()"
      [disabled]="loading || !client"
    >
      <mat-icon *ngIf="!loading">refresh</mat-icon>
      <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
      Обновить
    </button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <div class="loadError" *ngIf="error" role="alert"><mat-icon>error_outline</mat-icon><span>{{ error }}</span><button mat-stroked-button (click)="load()">Повторить</button></div>
  <div class="emptyState" *ngIf="!loading && !error && loaded && !calls.length">
    <mat-icon>phone_disabled</mat-icon>
    <div>
      <strong>Звонков пока нет</strong>
      <span>Когда Ringostat вернет записи по телефонам клиента, они появятся здесь.</span>
    </div>
  </div>

  <div class="tableScroll" *ngIf="calls.length">
    <table mat-table [dataSource]="calls" [trackBy]="trackByCall">
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef>Звонок</th>
        <td mat-cell *matCellDef="let call">
          <div class="summaryCell">
            <span class="dateText">{{ call.callDateLabel }}</span>
            <span [class]="getDirectionClass(call)">
              {{ getDirectionLabel(call) }}
            </span>
            <small *ngIf="call.callId">Идентификатор {{ call.callId }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="clientPhone">
        <th mat-header-cell *matHeaderCellDef>Клиент</th>
        <td mat-cell *matCellDef="let call">
          <span class="phoneText" [title]="call.clientPhone || '-'">
            {{ getClientPhoneLabel(call) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="managerNumber">
        <th mat-header-cell *matHeaderCellDef>Менеджер / линия</th>
        <td mat-cell *matCellDef="let call">
          <span class="truncateText" [title]="call.managerNumber || '-'">
            {{ getManagerLabel(call) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="result">
        <th mat-header-cell *matHeaderCellDef>Итог</th>
        <td mat-cell *matCellDef="let call">
          <span [class]="getStatusClass(call)">{{ getStatusLabel(call) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="recording">
        <th mat-header-cell *matHeaderCellDef>Запись</th>
        <td mat-cell *matCellDef="let call">
          <div class="recordingCell" *ngIf="call.recordingUrl; else noRecording">
            <span class="durationText">{{ call.durationLabel }} · {{ getRecordingLabel(call) }}</span>
            <audio controls preload="none" [src]="call.recordingUrl"></audio>
          </div>
          <ng-template #noRecording>
            <span class="noRecording">{{ call.durationLabel }} · Нет записи</span>
          </ng-template>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</mat-card>
